module.exports = __webpack_public_path__ + "img/NMK-teaser-back-768_1x.3693dc68.jpg";